import Vue from 'vue'
import startCase from 'lodash.startcase'
import moment from 'moment-timezone'

Vue.filter('capitalize', (value) => '' + value.charAt(0).toUpperCase() + value.slice(1))

Vue.filter('startCase', startCase)

Vue.filter('moment', v => moment.isMoment(v) ? v : moment(v))

Vue.filter('addHours', (v, h) => moment.isMoment(v) ? v.clone().add(h, 'hours') : moment(v).clone().add(h, 'hours'))

/**
 * Convert moment into specific timezone
 *
 * @param v datetime
 * @param timezone
 *
 * @return {moment}
 */
Vue.filter('timezone', (v, timezone) => moment.tz(v, timezone))

Vue.filter('date', v => v ? moment.utc(v).format('YYYY-MM-DD') + ' UTC' : '-')

Vue.filter('dateTime', v => v ? moment.utc(v).format('YYYY-MM-DD HH:mm') + ' UTC' : '-')

Vue.filter('timestamp', v => v.format('x'))

Vue.filter('toISOString', v => v.toISOString())

Vue.filter('maybe', v => v || '-')

Vue.filter('booleanYesNo', v => {
  switch (v) {
    case true:
      return 'Yes'
    case false:
      return 'No'
  }

  return 'Not Provided'
})

Vue.filter('notBooleanYesNo', v => {
  switch (v) {
    case false:
      return 'Yes'
    case true:
      return 'No'
  }

  return 'Not Provided'
})

/**
 * Break string at specific character index
 *
 * @params {String} string
 * @paramp {Integer} index
 */
Vue.filter('lineBreaker', (string, index) => [string.slice(0, index), string.slice(index)].join('\r\n'))

/**
 * Trim text and retain left and right chars
 *
 * @param v provided value
 * @param l number of chars to retain from left
 * @param r number of chars to retain from right
 * @param f middle filler text
 */
Vue.filter('trimmer', (v, l = 4, r = 4, f = '...') => (v.length > (l + r)) ? [v.slice(0, l), f, v.slice(-r)].join('') : v)

/**
 * Return minutes as hours and minutes
 */
Vue.filter('timeDuration', (minutes) => {
  if (isNaN(minutes)) {
    return '-'
  }

  if (minutes <= 60) {
    const remainingMinutes = Math.floor(minutes)
    return `${remainingMinutes} minutes`
  }

  const hours = Math.floor(minutes / 60)
  const remainingMinutes = Math.floor(minutes % 60)

  return `${hours} hour` + (hours > 1 ? 's' : '') + ` and ${remainingMinutes} minutes`
})
